import React from "react";
import { useTranslation } from "react-i18next";
import "../styles/whiteContainer.css";

const WhiteContainer = () => {
  const { t } = useTranslation();
  const items = t("home.slider.items", { returnObjects: true });

  return (
    <div className="white-containerComponent">
      <div className="white-containerComponent">
        <div className="sentence-slider">
          <div className="slider-track">
            {Array.isArray(items) &&
              items.map((item, i) => <span key={i}>{item}</span>)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhiteContainer;
